export enum PriceType {
  ForSale = 1,
  ForRent = 2,
}

export type LocationKind = 'city' | 'region' | 'location';

export type GeoCoordinates = {
  readonly latitude: number;
  readonly longitude: number;
};

export type Location = {
  readonly id: number;
  readonly name: string;
  readonly kind: LocationKind;
  readonly typeLabel: string;
  readonly coordinates?: GeoCoordinates;
  readonly cityId?: number;
  readonly regionId?: number;
  readonly genitiveName?: string;
};

export type AutocompleteResult = {
  key: string;
  location: Location;
};

export type EntityKind = 'project' | 'builder';

export type AutocompleteEntity = {
  readonly kind: EntityKind;
  readonly id: number;
  readonly name: string;
  readonly typeLabel: string;
};

export type AutocompleteSuggestions = {
  readonly locations: AutocompleteResult[];
  readonly projects: AutocompleteEntity[];
  readonly builders: AutocompleteEntity[];
};

export interface SearchResults {
  items: number[];
  page: number;
  pages: number;
}
